import { render, staticRenderFns } from "./addPeopleDialog.vue?vue&type=template&id=37523512&scoped=true&"
import script from "./addPeopleDialog.vue?vue&type=script&lang=js&"
export * from "./addPeopleDialog.vue?vue&type=script&lang=js&"
import style0 from "./addPeopleDialog.vue?vue&type=style&index=0&id=37523512&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37523512",
  null
  
)

export default component.exports